export type OrderInitiatedPayment = {
  redirectUrl: string
}

const buildOrderInitiatedPayment = function () : OrderInitiatedPayment {
  return {
    redirectUrl: ''
  }
}

export {
  buildOrderInitiatedPayment
}



// WEBPACK FOOTER //
// ./src/types/order-initiated-payment.js